<template>
  <div
    class="uploaded-media"
    v-loading="isLoading"
    element-loading-text="画像をアップロードしています。 しばらくお待ちください。"
  >
    <el-button v-if="!imageUrl" type="primary" @click="triggerUpload"> アップロード </el-button>
    <div v-if="imageUrl">
      <div class="media-preview">
        <i class="mdi mdi-close" @click="removeMedia()"></i>
        <div class="media-name">{{ imageOriginName }}</div>
        <img :src="imageUrl" class="direct-media mt-x1" />
      </div>
      <div class="mt-x2">
        <label class="el-button el-button--default" @click="triggerUpload">
          <i class="mdi mdi-image"></i>
          <span v-if="imageUrl">画像を変更</span>
        </label>
      </div>
    </div>
    <span class="media-limit-text">{{ maxFileSizeText }}</span>
    <input type="file" style="display: none" @change="handleFileChange($event)" :accept="accept" ref="fileInput" />
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ImageUpload',
  emits: ['remove-media', 'file-change'],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: 'image/jpeg,image/png,image/pjpeg,image/gif'
    },
    imageUrl: {
      type: String as PropType<string | null>,
      default: null
    },
    imageOriginName: {
      type: String as PropType<string | null>,
      default: null
    },
    maxFileSizeText: {
      type: String,
      default: 'アップロード可能最大サイズ: 画像5MB'
    }
  },
  methods: {
    triggerUpload(): void {
      ;(this.$refs.fileInput as HTMLInputElement).click()
    },
    removeMedia(): void {
      this.$emit('remove-media')
    },
    handleFileChange(event: Event): void {
      this.$emit('file-change', event)
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.uploaded-media {
  width: 100%;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: $round $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: $round;
    right: $round;
    cursor: pointer;
  }
}

.media-limit-text {
  display: block;
  margin-top: $spacing-unit;
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}
</style>
